import React from 'react';
// ANTD
import Button from 'components/common/Button';
import Col from 'antd/lib/col';
import Row from 'components/common/Row';
import Modal from 'antd/lib/modal';
//
import SignatureForm from './SignatureForm';
import SignaturePreview from './SignaturePreview';

class SignatureModal extends React.Component {
  state = {
    loading: false,
  };

  renderTopRow = () => {
    const { userFullName, signatureText, signatureType } = this.props;
    return (
      <Row style={{ minHeight: 170 }}>
        <Col xs={24} sm={14}>
          <SignatureForm
            userFullName={userFullName || 'Your Name'}
            signatureText={signatureText}
            signatureType={signatureType}
            onChange={this.props.onChange}
          />
        </Col>
        <Col xs={24} sm={10}>
          <SignaturePreview signatureText={signatureText} />
        </Col>
      </Row>
    );
  };

  handleOnClick = () => {
    this.setState({ loading: true });
    setTimeout(() => {
      this.setState({ loading: false });
      this.props.onChange({
        [`${this.props.signatureType}SignDate`]: new Date(),
      });
      this.props.onCompleteSignature();
    }, 1700);
  };

  renderBottomRow = () => (
    <Row type="flex" align="middle" justify="center" style={{ height: 75 }}>
      <Col xs={0} sm={14} />
      <Col xs={24} sm={10}>
        <Button
          loading={this.state.loading}
          style={{
            letterSpacing: '.065em',
            padding: '11px 22px 8px',
            alignSelf: 'center',
            display: 'block',
            minWidth: 200,
            height: 45,
            fontSize: 16,
            maxWidth: '100%',
          }}
          onClick={this.handleOnClick}
        >
          {!this.state.loading ? 'CONFIRM SIGNATURE' : 'SIGNING...'}
        </Button>
      </Col>
    </Row>
  );

  render() {
    const { signModalVisible, toggleSignatureModal } = this.props;

    return (
      <div>
        <Modal
          footer={null}
          title="Sign Contract"
          visible={signModalVisible}
          width={650}
          onCancel={toggleSignatureModal}
        >
          {this.renderTopRow()}
          {this.renderBottomRow()}
        </Modal>
      </div>
    );
  }
}

export default SignatureModal;



// WEBPACK FOOTER //
// ./src/routes/contract-sign/ContractPDF/SignatureModal/index.js